module.exports = __webpack_public_path__ + "files/8dd42e02d20082db960018b6488338f7.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Main-Italic.woff
// module id = 1183
// module chunks = 76